import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Styled Elements
// import { TableWrapper } from './ReportsAddress.elements'

// Utils
import { getCustomerStatus } from 'common/utils/customerValidation'

import { App, Header, Sidebar, Content, PageWrapper, ReportsSubHeader } from 'views/layouts'
import { ReportsAddressTable, DemoReportsTable } from 'views/containers'
import { Container } from 'views/components'

function ReportsAddress() {
  const [csi] = useState(getCustomerStatus())

  return (
    <App>
      <Sidebar />
      <Header subHeader={<ReportsSubHeader />} pageTitle="Reports" />
      <Content>
        <PageWrapper>
          <Container>
            {csi === 1 && <ReportsAddressTable />}

            {csi !== 1 && <DemoReportsTable />}
          </Container>
        </PageWrapper>
      </Content>
    </App>
  )
}

// Default Props
ReportsAddress.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
ReportsAddress.propTypes = {
  actions: PropTypes.shape({
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    showAlert: PropTypes.func,
  }),
  filters: PropTypes.shape({
    whitelistingFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
}

export default ReportsAddress
